<template>
  <b-row>

    <vue-modal
      :on-close="onBtnClosePopup"
      :name="modalName"
    >
      <h2 slot="header">
        รายการร้องทุกข์ใหม่รอดำเนินการ
      </h2>

      <commonTable2
        :mode="tab"
        @handleSend="getManageDetail"
        @handleGroup="getManageGroup"
      />

      <div class="text-center pt-1">

        <b-button
          variant="primary"
          class="mb-1 mb-sm-0 mr-0 mr-sm-1"
          @click="onBtnReceive"
        >
          รับเรื่อง
        </b-button>

        <b-button
          variant="secondary"
          @click="onBtnClosePopup"
        >
          ปิด
        </b-button>
      </div>
    </vue-modal>

    <b-col class="container text-right">
      <b-button
        variant="primary"
        @click="getManageGroup(1)"
      >
        <feather-icon
          icon="PlusIcon"
          class="mr-25"
        />
        <span>เพิ่มข้อมูล</span>
      </b-button>
    </b-col>

    <b-card class="mt-2 col-12">
      <b-tabs>
        <b-tab
          v-for="tab in tabs"
          :key="tab.title"
          :title="tab.title"
          lazy
          @click.prevent="setActiveTabName(tab.mode)"
        >
          <b-col cols="12">
            <SearchFilter :mode="tab.mode" />
          </b-col>

        </b-tab>
      </b-tabs>

    </b-card>

    <b-col
      v-for="tab in activeTab"
      :id="tab"
      :key="tab"
      cols="12"
    >
      <commonTable
        :mode="tab"
        @handleSend="getManageDetail"
        @handleGroup="getManageGroup"
      />
    </b-col>
  </b-row>
</template>

<script>
import {
  BRow, BCol, BTabs, BTab, BButton, BCard, BCardHeader, BCardBody,
} from 'bootstrap-vue'
import commonTable from '../../table/vue-good-table/commonTableScreening.vue'
import commonTable2 from '../../table/vue-good-table/commonTableModal.vue'
import SearchFilter from './components/SearchFilter.vue'

export default {
  components: {
    BRow,
    BCol,
    BButton,
    BTabs,
    BTab,
    BCard,
    BCardHeader,
    BCardBody,
    commonTable,
    commonTable2,
    SearchFilter,

  },
  data() {
    return {
      tabs: [
        { title: 'รายการเรื่องร้องทุกข์', mode: 'List' },
        { title: 'ประวัติดำเนินการ', mode: 'Group' },
      ],
      activeTab: ['List'],
      modalName: 'my-modal',
    }
  },
  beforeMount() {
    this.$modals.show(this.modalName)
  },
  methods: {
    setActiveTabName(name) {
      this.activeTab = []
      this.activeTab.push(name)
    },
    getManageDetail(id) {
      // let routeData = this.$router.resolve({name: 'LawScreeningManage', query: { id:id } });
      // window.open(routeData.href, '_blank');
    },
    getManageGroup(id) {
      // let routeData = this.$router.resolve({name: 'LawGroupdManage' });
      // window.open(routeData.href, '_blank');
      const routeData = this.$router.resolve({ name: 'provoffManage', query: { id } })
      window.open(routeData.href, '_blank')
    },
    onBtnClosePopup() {
      if (this.$modals.isActive(this.modalName) === true) this.$modals.hide(this.modalName)
    },
    onBtnReceive() {
      if (this.$modals.isActive(this.modalName) === true) this.$modals.hide(this.modalName)
    },
  },
}
</script>

 <style lang="scss" >
@import '@core/scss/vue/libs/vue-good-table.scss';
</style>
